// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "TestimonialsSection-module--wrapper--6N0ZX";
export var carouselWrapper = "TestimonialsSection-module--carouselWrapper--O7vZS";
export var carouselCounter = "TestimonialsSection-module--carouselCounter--rvMr2";